import React, { useState, useEffect } from 'react';
import { getCountry, getRestaurants, deleteRestaurant } from '../../apis/resturants-winerise';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useNavigate, useParams } from 'react-router-dom';
import { API } from "../../apis/constants";
import { Toast } from '../alert';
import {
  Card,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Grid,
  Box,
  Container,
  Modal,
  Button,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';

const FoodCategory = ({ image, title, isOpen, anchorEl, toggleDropdown, id, handleOptions }) => {
  const options = [
    {
      name: "Update Details",
      icon: <ModeEditIcon fontSize="small" />,
    },
    {
      name: "Delete",
      icon: <DeleteIcon fontSize="small" />,
    },
  ];

  return (
    <Card sx={{ p: 2, '&:hover': { boxShadow: 6 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box
            sx={{
              width: 96,
              height: 96,
              borderRadius: '50%',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: 'grey.300',
              color: 'white',
              fontSize: 24,
              fontWeight: 'bold',
            }}
          >
            {image ? (
              <img
                src={image}
                alt={title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            ) : (
              title
                .split(' ')
                .map((word) => word[0])
                .join('')
                .toUpperCase()
            )}
          </Box>
          <Typography variant="h6" component="h3">
            {title}
          </Typography>
        </Box>
        <IconButton
          onClick={toggleDropdown}
          size="small"
          sx={{ width: 24, height: 24 }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={isOpen}
          onClose={() => toggleDropdown(null)}
        >
          {options.map((option, index) => (
            <MenuItem
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}
              key={index}
              onClick={() => {
                handleOptions(option, id);
                toggleDropdown(null);
              }}
            >
              {option.name}
              {option.icon}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Card>
  );
};

const Index = () => {
  const { id } = useParams(); 
  const [loading, setisLoading] = useState(false);
  const [restaurants, setrestaurants] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false); // State for delete confirmation modal
  const [selectedRestaurantId, setSelectedRestaurantId] = useState(null); // State for the restaurant ID to delete

  useEffect(() => {
    if (loading) return;
    fetchData();
  }, []);

  useEffect(() => {
    if (loading) return;
    fetchrestaurants();
  }, []);


  const fetchrestaurants = async () => {
    const endpoint = `/api/dine/restaurants`; // Append the id to the endpoint
    let resData = await getRestaurants(endpoint, 'GET', id);
    setrestaurants(resData);
    setisLoading(false);
  };

  let navigate = useNavigate();

  const handleOptions = (option, locId) => {
    switch (option.name) {
      case "Update Details":
        navigate(`/resturant-wineries/details/${locId}?locId=${id}`);
        break;
      case "Delete":
        setSelectedRestaurantId(locId); // Set the restaurant ID to delete
        setDeleteModalOpen(true); // Open the delete confirmation modal
        break;
      default:
        break;
    }
  };

  const handleDelete = async () => {
    try {
      await deleteRestaurant(`/api/dine/restaurants/${selectedRestaurantId}`, 'DELETE', {'_method':'DELETE'}); // Call the delete API
      Toast('success', 'Restaurant deleted successfully');
      setDeleteModalOpen(false); // Close the modal
      fetchrestaurants(); // Refresh the restaurant list
    } catch (error) {
      Toast('error', 'Failed to delete the restaurant');
      setDeleteModalOpen(false); // Close the modal
    }
  };

  const fetchData = async () => {
    setisLoading(true);
    await getCountry('/api/dine/country', 'GET');
    setisLoading(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (event, categoryId) => {
    setAnchorEl(event ? event.currentTarget : null);
    setOpenDropdown(openDropdown === categoryId ? null : categoryId);
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', py: 4 }}>
      <Container maxWidth="xl">
        {loading ? (
          <Grid container spacing={3}>
            {[...Array(8)].map((_, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Card sx={{ p: 2, '&:hover': { boxShadow: 6 } }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box
                      sx={{
                        width: 96,
                        height: 96,
                        borderRadius: '50%',
                        bgcolor: 'grey.300',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    />
                    <Typography variant="h6" component="h3" sx={{ bgcolor: 'grey.300', height: 24, width: '60%' }} />
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {restaurants.length > 0 ? (
              restaurants.map((category) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={category.id}>
                  <FoodCategory
                    image={category.image ? API.baseUrl + category.image : null}
                    title={category.name}
                    id={category.id}
                    isOpen={openDropdown === category.id}
                    anchorEl={anchorEl}
                    toggleDropdown={(e) => handleDropdownToggle(e, category.id)}
                    handleOptions={handleOptions}
                  />
                </Grid>
              ))
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '200px',
                }}
              >
                <Typography variant="h6" component="h6">
                  No RESTAURANT FOUND
                </Typography>
              </Grid>
            )}
          </Grid>
        )}
      </Container>

      {/* Delete Confirmation Modal */}
      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)} // Close modal on backdrop click
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" gutterBottom>
            Are you sure?
          </Typography>
          <Typography variant="body1" gutterBottom>
            You want to delete the restaurant.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 3 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setDeleteModalOpen(false)} // Close modal on cancel
              sx={{ width: '45%' }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDelete} // Call delete function
              sx={{ width: '45%' }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Index;
